import React from 'react';

import {Box, Stack, Typography} from '@mui/material';
import {AlertInfo} from 'presentation/components';
import {CopySectionMaskEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {useContractStatus} from 'presentation/hooks';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {CHANNELS_CONTACTS} from 'presentation/pages/private/help/constants/channelsContacts';
import {ChannelAccordion} from 'presentation/pages/private/help/components/ContactChannels/components/ChannelAccordion';
import {ChannelPhone} from 'presentation/pages/private/help/components/ContactChannels/components/ChannelPhone';
import {ChannelRegion} from 'presentation/pages/private/help/components/ContactChannels/components/ChannelRegion';
import {FinancialSupportAccordion} from 'presentation/pages/private/help/components/ContactChannels/components/FinancialSupportAccordion';
import {ContactChannelsBrandProps} from 'presentation/pages/private/help/components/ContactChannels/types';
import {HelpPageTaggingEnum} from 'main/analytics/gaTagsEnum';

const {title, healthExamsAppointments, SAC, centralServices, financialSupport} =
	translations['pt-br'].privateFlow.help.channels.clinipam;

export function ClinipamContactChannels({
	expandedState,
	handleAccordionToggle,
}: ContactChannelsBrandProps) {
	const {isValid} = useContractStatus();
	const {isResponsibleWithoutBenefits, healthOnly} = useAccountInformation();
	return (
		<Stack gap={1}>
			<Typography variant="subheader">{title}</Typography>

			<Box>
				{isValid && !isResponsibleWithoutBenefits ? (
					<ChannelAccordion
						dataTagId={HelpPageTaggingEnum.CLICK_EXPANDIR_TELEFONE_MARCACAO_AJUDA}
						title={healthExamsAppointments.title}
						handleAccordionToggle={handleAccordionToggle}
						expandedState={expandedState}>
						<Stack gap={2}>
							<AlertInfo.Root>{healthExamsAppointments.alert}</AlertInfo.Root>

							<ChannelRegion label={healthExamsAppointments.region1}>
								<ChannelPhone
									value={
										CHANNELS_CONTACTS.CLINIPAM.APPOINTMENTS_EXAMS
											.CAPITAL_METROPOLITAN.phone1
									}
									mask={CopySectionMaskEnum.PHONE_WITHOUT_DDD}
								/>
							</ChannelRegion>
							<ChannelRegion label={healthExamsAppointments.region2}>
								<ChannelPhone
									value={
										CHANNELS_CONTACTS.CLINIPAM.APPOINTMENTS_EXAMS
											.OTHER_LOCATIONS.phone1
									}
								/>
							</ChannelRegion>
						</Stack>
					</ChannelAccordion>
				) : null}
				<ChannelAccordion
					dataTagId={HelpPageTaggingEnum.CLICK_EXPANDIR_CENTRAL_SERVICOS_AJUDA}
					title={centralServices.title}
					handleAccordionToggle={handleAccordionToggle}
					expandedState={expandedState}>
					<Stack gap={2}>
						<ChannelRegion label={centralServices.region1}>
							<ChannelPhone
								value={
									CHANNELS_CONTACTS.CLINIPAM.CENTRAL_SERVICE.CAPITAL_METROPOLITAN
										.phone1
								}
								mask={CopySectionMaskEnum.PHONE_WITHOUT_DDD}
							/>
						</ChannelRegion>
						<ChannelRegion label={centralServices.region2}>
							<ChannelPhone
								value={
									CHANNELS_CONTACTS.CLINIPAM.CENTRAL_SERVICE.OTHER_LOCATIONS
										.phone1
								}
							/>
						</ChannelRegion>
						{!healthOnly ? (
							<ChannelRegion label={centralServices.interodonto}>
								<ChannelPhone
									value={
										CHANNELS_CONTACTS.CLINIPAM.CENTRAL_SERVICE.INTERODONTO
											.phone1
									}
								/>
							</ChannelRegion>
						) : null}
					</Stack>
				</ChannelAccordion>
				<ChannelAccordion
					dataTagId={HelpPageTaggingEnum.CLICK_EXPANDIR_TELEFONE_SAC_AJUDA}
					title={SAC.title}
					handleAccordionToggle={handleAccordionToggle}
					expandedState={expandedState}>
					<AlertInfo.Root sx={{mb: 1}}>{SAC.alert}</AlertInfo.Root>

					<ChannelPhone value={CHANNELS_CONTACTS.CLINIPAM.SAC.phone1} />
				</ChannelAccordion>
				<FinancialSupportAccordion
					title={financialSupport.title}
					expandedState={expandedState}
					handleAccordionToggle={handleAccordionToggle}
				/>
			</Box>
		</Stack>
	);
}
